import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-foreground text-white pt-24 md:pt-32 overflow-hidden" data-testid="site-footer">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 pb-16 md:pb-24 border-b border-white/10">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-white/50 font-medium mb-4">
            Ready when you are
          </p>
          <a
            href="#contact"
            data-testid="footer-cta-link"
            className="font-syne font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight hover:text-primary transition-colors duration-300 inline-flex items-center gap-3"
          >
            Start a project <ArrowUpRight size={36} className="text-primary" />
          </a>
        </div>
        <div className="flex gap-16 text-sm">
          <div className="space-y-3">
            <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Company</p>
            <a href="mailto:sivicbusinessdesign@gmail.com" data-testid="footer-link-email" className="block text-white/70 hover:text-white transition-colors duration-300">sivicbusinessdesign@gmail.com</a>
            <Link to="/admin" data-testid="footer-link-admin" className="block text-white/70 hover:text-white transition-colors duration-300">Admin</Link>
          </div>
        </div>
      </div>
      <h2
        className="font-syne font-bold tracking-tighter leading-none text-[22vw] md:text-[18vw] text-white/10 select-none -mb-[4vw] md:-mb-[3vw] mt-6"
        aria-hidden="true"
      >
        SIVIC
      </h2>
      <div className="relative border-t border-white/10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-white/40 bg-foreground">
        <p>© 2026 Sivic Business Design. All rights reserved.</p>
        <p>Design that builds businesses.</p>
      </div>
    </div>
  </footer>
);
